import { Link } from "@StarberryUtils"
import React from "react";
import { Container, Row, Col } from 'react-bootstrap';
import parse from 'html-react-parser';
import { VALUATION_PAGE_UEL } from "@Components/common/site/constants";
import './Buttons.scss';
import ScrollAnimation from 'react-animate-on-scroll';
import GetURL from '@Components/common/site/get-url';

const Buttons = (props) => {
  const { btns } = props
  if (btns) {
    return (
      <div className="btns">

        {btns.map((cta, k) => {
          if (cta.Cta_Label == "send_your_cv") {
            return (<button onClick={props.executeScroll} className="btn btn-primary">Send us your CV</button>)
          } else if (cta?.Cta_URL?.Secondary_URL) {
            if (cta?.Cta_URL?.Secondary_URL.includes("http")) {
              return (<a href={cta?.Cta_URL?.Secondary_URL} className="btn btn-primary" target="_blank" key={k}>{cta.Cta_Label}</a>)
            } else {
              return (<Link to={cta?.Cta_URL?.Secondary_URL} className="btn btn-primary" key={k}>{cta.Cta_Label}</Link>)
            } 
          } else {
            return (
              <GetURL label={cta.Cta_Label} alias={cta?.Cta_URL?.Alias} class="btn btn-primary" key={k} />
            )
          }

        })}
      </div>
    )
  }
  return <></>

}

export default Buttons;

